import { Col, Form, Row } from "antd";

import React from "react";
import CheckButton from "../../../../components/atoms/CheckButton";
import Explain from "../../../../components/atoms/Explain";
import RadioGroup from "../../../../components/atoms/RadioGroup";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import sharedConstants from "../../../../shared/constants";
import {
  getHolidayArray,
  holidayAllArray,
  isWorkAtHolidayArray,
} from "../../../../shared/options";
import { theme } from "../../../../theme";
import { RenderInputProps } from "../../Interface";

const { Item } = Form;
const HolidayInputs: React.FC<RenderInputProps> = ({ form }) => {
  const repairShopHolidayWorkdays = Form.useWatch(
    ["repairShopBusiness", "repairShopHolidayWorkdays"],
    form
  );
  const isWorkAtHoliday = Form.useWatch("isWorkAtHoliday", form);
  const isRestAllHoliday = [
    repairShopHolidayWorkdays?.length === getHolidayArray().length,
  ];

  return (
    <ExplainWrapper
      status={{
        status:
          form.getFieldError([
            "repairShopBusiness",
            "repairShopHolidayWorkdays",
          ])?.length > 0
            ? "error"
            : undefined,
        explain: form.getFieldError([
          "repairShopBusiness",
          "repairShopHolidayWorkdays",
        ])[0],
      }}
    >
      <Row gutter={[0, 0]}>
        <Col span={24}>
          <Item noStyle name="isWorkAtHoliday">
            <RadioGroup options={isWorkAtHolidayArray} />
          </Item>
        </Col>
        {isWorkAtHoliday && (
          <>
            <Col span={24}>
              <Explain
                color={theme.colors.gray3}
                status="question"
                explain="영업하는 공휴일을 선택해주세요."
              />
            </Col>
            <Col span={24}>
              <CheckButton
                value={isRestAllHoliday}
                onChange={(checkedValue) => {
                  form.setFieldsValue({
                    repairShopBusiness: {
                      repairShopHolidayWorkdays:
                        checkedValue[0] === true
                          ? getHolidayArray().map((val) => val.value)
                          : [],
                    },
                  });
                }}
                options={holidayAllArray}
              />
            </Col>
            <Col span={24}>
              <Item
                noStyle
                rules={[
                  {
                    validator: async () => {
                      if (isWorkAtHoliday)
                        if (repairShopHolidayWorkdays?.length === 0)
                          return Promise.reject(
                            new Error(
                              sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                            )
                          );
                      return Promise.resolve();
                    },
                  },
                ]}
                name={["repairShopBusiness", "repairShopHolidayWorkdays"]}
              >
                <CheckButton options={getHolidayArray()} />
              </Item>
            </Col>
          </>
        )}
      </Row>
    </ExplainWrapper>
  );
};

export default HolidayInputs;
